<div class="clearfix" data-aos="fade-up" [attr.id]="application ? 'data-ready-marker' : null">
  <ng-template #supportingDocsTpl let-section="section" let-label="label">
    <ng-container *ngIf="getDocumentsBySection(section) as docs">
      <div *ngIf="docs.length > 0" class="supporting-doc-section"
           style="margin:14px 12px 18px; padding:0; background:#ffffff; border:1px solid #d0d7e2; border-radius:6px; overflow:hidden;">
        <table class="supporting-doc-table"
               style="width:100%; border-collapse:collapse; font-size:12px; table-layout:fixed;">
          <colgroup>
            <col style="width:16%;" />
            <col style="width:16%;" />
            <col style="width:24%;" />
            <col style="width:14%;" />
            <col style="width:14%;" />
            <col style="width:16%;" />
          </colgroup>
          <thead>
            <tr>
              <th style="background:#e6f3fd !important; color:#1a1a1a; font-weight:600; padding:8px 10px; border:1px solid #cfe4f5; text-align:left;">Category</th>
              <th style="background:#e6f3fd !important; color:#1a1a1a; font-weight:600; padding:8px 10px; border:1px solid #cfe4f5; text-align:left;">Type</th>
              <th style="background:#e6f3fd !important; color:#1a1a1a; font-weight:600; padding:8px 10px; border:1px solid #cfe4f5; text-align:left;">Filename</th>
              <th style="background:#e6f3fd !important; color:#1a1a1a; font-weight:600; padding:8px 10px; border:1px solid #cfe4f5; text-align:left;">Document Status</th>
              <th style="background:#e6f3fd !important; color:#1a1a1a; font-weight:600; padding:8px 10px; border:1px solid #cfe4f5; text-align:left;">Uploaded By</th>
              <th style="background:#e6f3fd !important; color:#1a1a1a; font-weight:600; padding:8px 10px; border:1px solid #cfe4f5; text-align:left;">Date Uploaded</th>
            </tr>
          </thead>
          <tbody>
           <tr *ngFor="let doc of docs; let odd = odd"
                [style.background]="odd ? '#f7fafc' : '#ffffff'">
              <!-- <td style="padding:8px 10px; border:1px solid #e2e6ea; color:#212529; vertical-align:top; word-break:break-word;">{{ getDocCategoryLabel(doc) || '-' }}</td> -->
               <td style="padding:8px 10px; border:1px solid #e2e6ea; color:#212529; vertical-align:top; word-break:break-word;">
                {{ getDocCategoryLabel(doc) || '-' }}
                <span *ngIf="getDocCategoryLabel(doc)?.includes('Proof of Photo Identification')" style="color:#dc3545;">*</span>
              </td>
              <td style="padding:8px 10px; border:1px solid #e2e6ea; color:#212529; vertical-align:top; word-break:break-word;">{{ getDocTypeLabel(doc) || '-' }}</td>
              <td style="padding:8px 10px; border:1px solid #e2e6ea; color:#212529; vertical-align:top; word-break:break-all; line-height:1.35;">{{ doc?.file_name || '-' }}</td>
              <td style="padding:8px 10px; border:1px solid #e2e6ea; vertical-align:top;">
                <span *ngIf="doc?.status; else noStatus" [attr.style]="getDocStatusBadgeStyle(doc?.status)">{{ doc?.status }}</span>
                <ng-template #noStatus><span style="color:#212529;">-</span></ng-template>
              </td>
              <td style="padding:8px 10px; border:1px solid #e2e6ea; color:#212529; vertical-align:top; word-break:break-word;">{{ doc?.uploaded_by_name || '-' }}</td>
              <td style="padding:8px 10px; border:1px solid #e2e6ea; color:#212529; vertical-align:top; white-space:nowrap;">{{ formatDocumentDate(doc?.uploaded_at || doc?.created_date) || '-' }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </ng-container>
  </ng-template>
  <div class="clearfix" id="pdf-content" style="padding: 20px; position: relative">
    <div class="pdf-section">
      <div class="mb-3 w-100">
        <div class="p-3 border rounded bg-light">
          <div class="row">
            <div class="col-md-2 mb-2">
              <label><span id="application-id" class="font-weight-bold">Application ID</span>:
                {{ application?.application_number || '-' }}</label>
            </div>
            <div class="col-md-2 mb-2">
              <label><span class="font-weight-bold">Application Type</span>:
                {{ application?.cd_application_type || '-' }}</label>
            </div>
            <div *ngIf="application?.cd_application_type?.toLowerCase()!=='surrender'" class="col-md-2 mb-2">
              <label><span class="font-weight-bold">License Path</span>:
                {{ application?.license_path || '-' }}</label>
            </div>
            <div class="col-md-2 mb-2">
              <label><span class="font-weight-bold">Educator Name</span>:
                {{ (user?.person?.strFirstName || '') + ' ' + (user?.person?.strLastName || '-') }}</label>
            </div>
            <div class="col-md-2 mb-2">
              <label><span class="font-weight-bold">Submitted Date</span>:
                {{ application?.created_date ? (application?.created_date | date : 'MM/dd/yyyy') : '-' }}</label>
            </div>
            <div class="col-mb-2 mb-2" *ngIf="shouldShowLicenseNumber">
              <label><span class="font-weight-bold">License Number</span>:
                {{ license_number || '-' }}</label>
            </div>
          </div>
        </div>
      </div>

      <!-- Show Name Change fields when application type is 'name change' -->
      <div class="clearfix border-box" *ngIf="application?.cd_application_type?.toLowerCase() === 'name change'">
        <h5 class="Heading1 mb-0">Name History</h5>
        <div class="license-body border-body p-3">
          <div>
            <div class="row">
              <div class="col-md-12 mb-3">
                <label class="form-label">Name on Record</label>
                <input type="text" class="form-control"
                  [value]="(user?.person?.strFirstName || '') + ' ' + (user?.person?.strLastName || '') + ' ' + (user?.person?.strCdSuffix || '')"
                  placeholder="Enter Name on Record" />
              </div>
            </div>
            <div class="row">
              <div class="col-md-3 mb-3">
                <label class="form-label">New Legal First Name</label>
                <input type="text" class="form-control" placeholder="Enter First Name"
                  [value]="pf_name_history?.legal_first_name" />
              </div>
              <div class="col-md-3 mb-3">
                <label class="form-label">New Legal Middle Name</label>
                <input type="text" class="form-control" placeholder="Enter Middle Name"
                  [value]="pf_name_history?.legal_middle_name" />
              </div>
              <div class="col-md-3 mb-3">
                <label class="form-label">New Legal Last Name</label>
                <input type="text" class="form-control" placeholder="Enter Last Name"
                  [value]="pf_name_history?.legal_last_name" />
              </div>
              <div class="col-md-3 mb-3">
                <label class="form-label">New Legal Suffix</label>
                <input type="text" class="form-control" placeholder="Enter Suffix"
                  [value]="pf_name_history?.cd_suffix" />
              </div>
            </div>
          </div>
        </div>
        <ng-container *ngTemplateOutlet="supportingDocsTpl; context: { section: 'Name History', label: 'Supporting Documents - Name History' }"></ng-container>
      </div>
      <!-- Acknowledgement Section - Only show for name change applications -->
      <div class="clearfix border-box" *ngIf="application?.cd_application_type?.toLowerCase() === 'name change'">
        <h5 class="Heading1 mb-0">Acknowledgement</h5>
        <div class="border-body p-3">
          <div class="row mb-4">
            <div class="col-12 pl-0">
              <div class="form-check pl-0 ml-3">
                <input class="form-check-input" type="checkbox" id="nameChangeAcknowledgement"
                  [checked]="pf_name_history?.acknowledgement_flag" />
                <label class="form-check-label ml-3" for="nameChangeAcknowledgement">
                  I acknowledge the name change request and have uploaded both my updated photo ID and the legal name
                  change document(s) as required. <span class="text-danger">*</span>
                </label>
              </div>
            </div>
          </div>
          <div class="row mb-3">
            <div class="col-12">
              <p>
                By typing your full name below, you are electronically signing this application and certifying that
                the information provided is true and complete to the best of your knowledge.
              </p>
            </div>
          </div>
          <div class="row signfont">
            <div class="col-md-6">
              <label class="form-label">Signature - Applicant's Full Name <i class="fas fa-info-circle text-muted"></i>
                <span class="text-danger">*</span></label>
              <input type="text" class="form-control" placeholder="Enter First and Last Name" style="font-style: italic"
                [value]="application_acknowledgement?.oath_of_office_signature" />
            </div>
          </div>
        </div>
      </div>

      <div
        *ngIf="application?.cd_application_type?.toLowerCase() !== 'name change' && application?.cd_application_type?.toLowerCase() !== 'surrender'">
        <h1>License Details</h1>
        <!-- Application Instructions Section -->
        <div class="clearfix border-box">
          <h5 class="Heading1 mb-0">Application Instructions</h5>
          <div class="license-body border-body p-3">
            <p>
              Welcome to OPAL, the Nevada Department of Education's Online Portal for Application and Licensure! This
              new system will allow you to apply for a license or endorsement, renew an existing license, clear a
              provision on an existing license, and update personal or contact information securely online.
            </p>

            <p>
              Once you apply and submit payment for a license or renewal, your receipt will be emailed to you, along
              with information on how to submit your fingerprints for a background check. You will continue to receive
              text messages and email updates as your application moves through the review and approval process. When
              your background check clears and your application is approved, your official license will be sent to you
              via email.
            </p>
            <p>
              All applicants will be required to provide a copy of a valid government-issued photo ID. Licenses are
              issued with legal names and verification of legal name change will be required if any documents are under
              a name other than what is on the government-issued photo ID.
            </p>
            <p>
              Official hard copy transcripts can be sent via mail at the address provided on the Education tab of the
              application. If you mail in your transcripts, they must be original transcripts bearing the college or
              university seal. They do not have to be in a sealed envelope from the institution. Official electronic
              transcripts can be sent to transcripts@doe.nv.gov. Electronic transcripts will be accepted only if they
              are transmitted directly to the Department of Education from an accredited college or university if the
              institution is its own clearinghouse, or a recognized clearinghouse such as e-Script. Applicants may not
              email copies of their own transcripts. Test score reports and most other supporting documents may be
              uploaded within the online application.
            </p>
            <p>
              Applicants for a first-time license or renewal of a license must submit fingerprints for a background
              check pursuant to NRS 391.033. If you live in Nevada, you may submit your fingerprints electronically via
              Livescan. Applicants outside of Nevada who cannot submit prints via Livescan, and must submit a
              fingerprint card (FBI form FD-258) in person or by mail. Learn more about the
              <a href="https://doe.nv.gov/educator-licensure/background-process/" class="text-primary" target="_blank" rel="noopener noreferrer">fingerprinting and background process</a>.
            </p>
           <p>
              Additional information on the licensure process, as well as the minimum qualifications for licensure, may
              be found on our <a href="https://doe.nv.gov/educator-licensure/" class="text-primary" target="_blank" rel="noopener noreferrer">website</a>.
            </p>
          </div>
        </div>

        <!--Providers-->
        <div class="license-wrapper border-box" *ngIf="
            application?.cd_application_type?.toLowerCase() === 'arl' ||
            application?.cd_application_type?.toLowerCase() === 'Apprentice'
          ">
          <h5 class="mb-0">Provider</h5>
          <div class="license-body p-3">
            <div class="row">
              <div class="col-md-6">
                <label class="form-label" *ngIf="application?.cd_application_type?.toLowerCase() === 'arl'">ARL Provider
                  <span class="text-danger">*</span></label>
                <label class="form-label"
                  *ngIf="application?.cd_application_type?.toLowerCase() === 'apprentice'">Program Provider <span
                    class="text-danger">*</span></label>
                <input type="text" class="form-control" [value]="application_provider || ''"
                  placeholder="Select Provider" />
              </div>
            </div>
          </div>
           <ng-container *ngTemplateOutlet="supportingDocsTpl; context: { section: 'Provider', label: 'Supporting Documents - Provider' }"></ng-container>
        </div>

        <!-- Out of State Licensure -->
        <div class="license-wrapper border-box" *ngIf="application?.cd_application_type === 'Regular - Initial'">
          <h5 class="Heading1 mb-0">Out of State or Country Licensure</h5>
          <div class="license-body">
            <div class="license-section">
              <p>Do you have a valid educator license from another jurisdiction?</p>
              <div class="d-flex align-items-center mt-2 mb-2" style="gap: 1rem">
                <div class="form-check mb-0">
                  <input class="form-check-input" type="radio" name="activeLicense" id="activeLicenseYes" value="yes"
                    [checked]="application?.chk_valid_educator_license === true" />
                  <label class="form-check-label mt-1" for="activeLicenseYes">Yes</label>
                </div>
                <div class="form-check mb-0">
                  <input class="form-check-input" type="radio" name="activeLicense" id="activeLicenseNo" value="no"
                    [checked]="application?.chk_valid_educator_license === false" />
                  <label class="form-check-label mt-1" for="activeLicenseNo">No</label>
                </div>
              </div>
               <app-data-grid *ngIf="licenseoutofstateLicensureRows && licenseoutofstateLicensureRows.length > 0"
                [config]="application_out_of_state_licensure"> </app-data-grid>
            </div>
          </div>
          <ng-container *ngTemplateOutlet="supportingDocsTpl; context: { section: ['Out of State or Country Licensure', 'Out-of-State Licensure', 'out-of-state-lic_notes'], label: 'Supporting Documents - Out of State or Country Licensure' }"></ng-container>
        </div>

        <!-- Current License Kinds / Endorsements Section -->
        <div class="license-wrapper border-box" *ngIf="shouldShowCurrentLicenseKindEndorsements">
          <h5 class="Heading1 mb-0">Current License Kinds / Endorsements</h5>
          <div class="license-body">
            <div class="license-section">
                <app-data-grid
                [config]="current_license_kind_endorsement"
                [statusDataField]="'cd_endo_status'"
                [submittedStatusValues]="['Active']">
              </app-data-grid>
            </div>
          </div>
        </div>

        <!-- License & Endorsements Section -->
        <div class="license-wrapper border-box">
          <h5 class="Heading1 mb-0">{{ isRCRFlow ? 'New License Kinds / Endorsement' : 'License &amp; Endorsements' }}</h5>
          <div class="license-body">
            <div class="info-banner">
                <span class="text-danger">*</span>
                For more information on qualifying endorsements and licensure details please view them
                <a target="_blank" href="https://doe.nv.gov/educator-licensure/available-licenses" class="info-link">here</a>.
              </div>
            <div class="license-section">
              <app-data-grid *ngIf="licenseKindEndorsementRows && licenseKindEndorsementRows.length > 0"
                [config]="application_license_kind_endorsement"> </app-data-grid>
            </div>
          </div>
        </div>
         <!-- License Provisions Section -->
          <div class="license-wrapper border-box" *ngIf="shouldShowLicenseProvisions">
          <h5 class="Heading1 mb-0">License Provisions</h5>
          <div class="license-body">
            <div class="license-section">
              <app-data-grid [config]="license_provisions"></app-data-grid>
            </div>
          </div>
        </div>

         <!-- Endorsement Provisions Section -->
        <div class="license-wrapper border-box" *ngIf="shouldShowEndorsementProvisions">
          <h5 class="Heading1 mb-0">Endorsement Provisions</h5>
          <div class="license-body">
            <div class="license-section">
              <app-data-grid [config]="endorsement_provisions"></app-data-grid>
            </div>
          </div>
        </div>

        <!-- License Requirements Section -->
        <div class="license-wrapper border-box" *ngIf="shouldShowLicenseRequirements">
          <h5 class="Heading1 mb-0">License Requirements</h5>
          <div class="license-body">
            <div class="license-section">
              <app-data-grid [config]="license_requirements"></app-data-grid>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      *ngIf="application?.cd_application_type?.toLowerCase() !== 'name change' && application?.cd_application_type?.toLowerCase() !== 'surrender'">
      <div *ngIf="application?.cd_application_type?.toLowerCase() !== 'add endorsement'" class="pdf-section">
        <h1>Personal Information</h1>
        <!-- Identity and Contact Information Section -->
        <div class="clearfix border-box">
          <h5 class="Heading1 mb-0">Identity and Contact Information</h5>
          <div class="border-body p-3">
            <div class="row">
              <div class="col-md-3 mb-3">
                <label class="form-label">First Name</label>
                <input type="text" class="form-control" [value]="user?.person?.strFirstName || ''"
                  placeholder="Enter First Name" />
              </div>
              <div class="col-md-3 mb-3">
                <label class="form-label">Middle Name</label>
                <input type="text" class="form-control" [value]="user?.person?.strMiddleName || ''"
                  placeholder="Enter Middle Name" />
              </div>
              <div class="col-md-3 mb-3">
                <label class="form-label">Last Name</label>
                <input type="text" class="form-control" [value]="user?.person?.strLastName || ''"
                  placeholder="Enter Last Name" />
              </div>
              <div class="col-md-3 mb-3">
                <label class="form-label">Suffix</label>
                <input type="text" class="form-control" [value]="user?.person?.strCdSuffix || ''"
                  placeholder="Enter Suffix" />
              </div>
            </div>
            <div class="row">
              <div class="col-md-3 mb-3">
                <label class="form-label">Date of Birth</label>
                <input type="text" class="form-control"
                  [value]="user?.person?.strDateOfBirth ? (user?.person?.strDateOfBirth | date:'MM/dd/yyyy' ) : ''"
                  placeholder="Select Date of Birth" />
              </div>
              <div class="col-md-3 mb-3">
                <label class="form-label">Social Security Number</label>
                <input type="text" class="form-control" ssnMask
                  [value]="user?.person?.strSsnNumber ? '***-**-' + (user?.person?.strSsnNumber | slice: -4) : '' "
                  placeholder="Enter SSN Number" />
              </div>
            </div>
            <div class="row">
              <div class="col-md-3 mb-3">
                <label class="form-label">Email</label>
                <input type="email" class="form-control" [value]="user?.person?.strPrimaryEmail || ''"
                  placeholder="Enter Email" />
              </div>
              <div class="col-md-3 mb-3">
                <label class="form-label">Recovery Email</label>
                <input type="email" class="form-control" [value]="user?.person?.strRecoveryEmail || ''"
                  placeholder="Enter Recovery Email" />
              </div>
              <div class="col-md-3 mb-3">
                <label class="form-label">Phone Number</label>
                <input type="tel" class="form-control"
                  [value]="user?.person?.strPrimaryPhone ? '(' + user?.person?.strPrimaryPhone.slice(0, 3) + ') ' + user?.person?.strPrimaryPhone.slice(3, 6) + '-' + user?.person?.strPrimaryPhone.slice(6, 10) : ''"
                  placeholder="Enter Phone Number" />
              </div>
              <div class="col-md-3 mb-3">
                <label class="form-label">Alternate Phone</label>
                <input type="tel" class="form-control"
                  [value]="user?.person?.strAlternatePhone ? '(' + user?.person?.strAlternatePhone.slice(0, 3) + ') ' + user?.person?.strAlternatePhone.slice(3, 6) + '-' + user?.person?.strAlternatePhone.slice(6, 10) : ''"
                  placeholder="Enter Phone Number" />
              </div>
            </div>
          </div>
           <ng-container *ngTemplateOutlet="supportingDocsTpl; context: { section: 'Identity and Contact Information', label: 'Supporting Documents - Identity and Contact Information' }"></ng-container>
        </div>

        <!-- Address Information Section -->
        <div class="clearfix border-box">
          <h5 class="Heading1 mb-0">Address Information</h5>
          <div class="license-body">
            <div class="border-body p-3">
              <div class="row">
                <div class="p-field col-md-3 col-sm-6">
                  <label class="referral-form-labels common-label">Country <span class="text-danger">*</span></label>
                  <input type="text" class="form-control w-100" [value]="pf_address_info?.country"
                    placeholder="select one" />
                </div>
                <div class="col-md-3 mb-3">
                  <label class="form-label">Street Address <span class="text-danger">*</span></label>
                  <input type="text" class="form-control" placeholder="Enter Street Address"
                    [value]="pf_address_info?.street_address" />
                </div>
                <div class="col-md-3 mb-3">
                  <label class="form-label">Address Line 2</label>
                  <input type="text" class="form-control" placeholder="Enter Address Line 2"
                    [value]="pf_address_info?.address_line2" />
                </div>
                <div class="col-md-3 mb-3">
                  <label class="form-label">ZIP Code <span class="text-danger">*</span></label>
                  <input type="text" class="form-control" placeholder="Enter ZIP Code"
                    [value]="pf_address_info?.postal_code" />
                </div>
              </div>
              <div class="row">
                <div class="col-md-3 mb-3">
                  <label class="form-label">City <span class="text-danger">*</span></label>
                  <input type="text" class="form-control" placeholder="Enter City" [value]="pf_address_info?.city" />
                </div>
                 <div class="col-md-3 mb-3">
                  <label class="form-label">County</label>
                  <input type="text" class="form-control" placeholder="Enter County" [value]="pf_address_info?.county" />
                </div>
                <div class="col-md-3 mb-3">
                  <label class="form-label">State <span class="text-danger">*</span></label>
                  <input type="text" class="form-control" placeholder="Enter State" [value]="pf_address_info?.state" />
                </div>
              </div>
              <div class="row">
                <div class="col-12 mb-3 pl-0 ml-3">
                  <input type="checkbox" id="sameAddress" [checked]="pf_address_info?.is_mailing_address" />
                  <label class="form-check-label mb-0 ml-3" for="sameAddress"> Mailing address same as above </label>
                </div>
              </div>
              <div *ngIf="!pf_address_info?.is_mailing_address">
                <div class="row">
                  <div class="p-field col-md-3 col-sm-6">
                    <label class="referral-form-labels common-label">Country <span class="text-danger">*</span></label>
                    <input type="text" class="form-control w-100" [value]="pf_address_info?.m_country"
                      placeholder="select one" />
                  </div>
                  <div class="col-md-3 mb-3">
                    <label class="form-label">Mailing Address <span class="text-danger">*</span></label>
                    <input type="text" class="form-control" placeholder="Enter Mailing Address"
                      [value]="pf_address_info?.m_street_address" />
                  </div>
                  <div class="col-md-3 mb-3">
                    <label class="form-label">Address Line 2</label>
                    <input type="text" class="form-control" placeholder="Enter Address Line 2"
                      [value]="pf_address_info?.m_address_line2" />
                  </div>
                  <div class="col-md-3 mb-3">
                    <label class="form-label">ZIP Code <span class="text-danger">*</span></label>
                    <input type="text" class="form-control" placeholder="Enter ZIP Code"
                      [value]="pf_address_info?.m_postal_code" />
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-3 mb-3">
                    <label class="form-label">City <span class="text-danger">*</span></label>
                    <input type="text" class="form-control" placeholder="Enter City"
                      [value]="pf_address_info?.m_city" />
                  </div>
                  <div class="col-md-3 mb-3">
                    <label class="form-label">County <span class="text-danger">*</span></label>
                    <input type="text" class="form-control" placeholder="Enter County"
                      [value]="pf_address_info?.m_county" />
                  </div>
                  <div class="col-md-3 mb-3">
                    <label class="form-label">State <span class="text-danger">*</span></label>
                    <input type="text" class="form-control" placeholder="Enter State"
                      [value]="pf_address_info?.m_state" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Demographics Section -->
        <div class="clearfix border-box">
          <h5 class="Heading1 mb-0">Demographics</h5>
          <div class="license-body">
            <div class="border-body p-3">
              <div class="row">
                <div class="p-field col-md-3 col-sm-6">
                  <label class="referral-form-labels common-label">Gender</label>
                  <input type="text" class="form-control w-100" [value]="user?.person?.strCdGender || 'Select One'" />
                </div>
                <div class="p-field col-lg-4 col-md-4 col-sm-6 col-12">
                  <label class="referral-form-labels common-label">Race</label>
                  <input type="text" class="form-control w-100" [value]="user?.person?.strCdRace || 'Select One'" />
                </div>
                <div class="p-field col-lg-4 col-md-4 col-sm-6 col-12">
                  <label class="referral-form-labels common-label">Ethnicity</label>
                  <input id="Email-Address" type="text" class="form-control" aria-describedby="add-policyNumber"
                    [readonly]="readOnlyMode" [value]="user?.person?.strCdEthnicity || 'Select One'" />
                </div>
              </div>
            </div>
          </div>

          <!-- Name History Section -->
          <div class="clearfix border-box">
            <h5 class="Heading1 mb-0">Name History</h5>
            <div class="border-body p-3">
              <div class="row">
                <div class="col-md-6 mb-3">
                  <label class="form-label">Name on Record</label>
                  <!-- <input
                    type="text"
                    class="form-control"
                    [value]="user?.person?.strFirstName + ' ' + user?.person?.strLastName"
                    placeholder="Enter Name on Record" /> -->
                  <input type="text" class="form-control"
                    [value]="(user?.person?.strFirstName || '') + ' ' + (user?.person?.strLastName || '') + ' ' + (user?.person?.strCdSuffix  || '')"
                    placeholder="Enter Name on Record" />
                </div>
                <div class="col-md-6 mb-3">
                  <label class="form-label">Do you need to update your legal name? <span
                      class="text-danger">*</span></label>
                  <div class="d-flex align-items-center mt-2" style="gap: 1rem">
                    <div class="form-check mb-0">
                      <input class="form-check-input" type="radio" name="updateName" id="updateNameYes" value="yes"
                        [checked]="pf_name_history?.is_update_legal_name === true"
                        (change)="onChangeUpdateNames($event)" />
                      <label class="form-check-label mt-1" for="updateNameYes">Yes</label>
                    </div>
                    <div class="form-check mb-0">
                      <input class="form-check-input" type="radio" name="updateName" id="updateNameNo" value="no"
                        [checked]="pf_name_history?.is_update_legal_name === false"
                        (change)="onChangeUpdateNames($event)" />
                      <label class="form-check-label mt-1" for="updateNameNo">No</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div *ngIf="pf_name_history?.is_update_legal_name === true">
              <div class="row">
                <div class="col-md-3 mb-3">
                  <label class="form-label">New Legal First Name</label>
                  <input type="text" class="form-control" placeholder="Enter First Name"
                    [value]="pf_name_history?.legal_first_name" />
                </div>
                <div class="col-md-3 mb-3">
                  <label class="form-label">New Legal Middle Name</label>
                  <input type="text" class="form-control" placeholder="Enter Middle Name"
                    [value]="pf_name_history?.legal_middle_name" />
                </div>
                <div class="col-md-3 mb-3">
                  <label class="form-label">New Legal Last Name</label>
                  <input type="text" class="form-control" placeholder="Enter Last Name"
                    [value]="pf_name_history?.legal_last_name" />
                </div>
                <div class="col-md-3 mb-3">
                  <label class="form-label">New Legal Suffix</label>
                  <input type="text" class="form-control" placeholder="Enter Suffix"
                    [value]="pf_name_history?.cd_suffix" />
                </div>
              </div>
              <div class="license-body">
                <div class="license-section">
                  <app-data-grid *ngIf="priorNamesRows && priorNamesRows.length > 0" [config]="pf_prior_names">
                  </app-data-grid>
                </div>
              </div>
            </div>
          </div>
        </div>
      <ng-container *ngTemplateOutlet="supportingDocsTpl; context: { section: 'Name History', label: 'Supporting Documents - Name History' }"></ng-container>
        </div>
      <!-- Veteran Status Section -->
      <div class="pdf-section">
        <div *ngIf="application?.cd_application_type?.toLowerCase() !== 'add endorsement'" class="clearfix border-box">
          <h5 class="Heading1 mb-0">Veteran Status</h5>
          <div class="border-body p-3">
            <div ref="component"
              class="formio-component formio-component-htmlelement formio-component-veteranContent app-para"
              id="env8sgc">
              <p class="formio-component-htmlelement mt-2 mb-4 app-para blue-bg">
                <strong>Military Service Information - AS REQUIRED BY EXECUTIVE ORDER 2014-20</strong><br /><br />
                You may be eligible to receive a reduced fee if you or your spouse is currently serving or is a veteran*
                of the United States Armed Forces. To receive the reduced fee you will need to submit a copy of your
                current military identification card or DD-214 for proof of service. If you submit documents for your
                spouse’s military service you will also be required to submit a marriage certificate for proof of
                relationship. The marriage certificate should be uploaded in the Personal Information tab. These
                documents will be verified upon submission of your application. If you mark "Yes" and do not provide the
                required documentation after receiving the reduced fee, you will be invoiced for the balance.
                <br /><br />
                *Title 38 of the Code of Federal Regulations defines a veteran as "a person who served in the active
                military, naval, or air service and who was discharged or released under conditions other than
                dishonorable.
              </p>

              <div class="formio-errors invalid-feedback" ref="messageContainer"></div>
            </div>
            <div class="row">
              <div class="col-md-3 mb-3">
                <label class="form-label">Do you meet the definition of a veteran as provided above? <span
                    class="text-danger">*</span></label>
                <div class="d-flex align-items-center mt-2" style="gap: 1rem">
                  <div class="form-check mb-0">
                    <input class="form-check-input" type="radio" name="veteran" id="veteranYes" value="yes"
                      [checked]="pf_veteran_status?.is_meets_veteran_definition === true"
                      (change)="onChangeVeteranDefinition($event)" />
                    <label class="form-check-label mt-1" for="veteranYes">Yes</label>
                  </div>
                  <div class="form-check mb-0">
                    <input class="form-check-input" type="radio" name="veteran" id="veteranNo" value="no"
                      [checked]="pf_veteran_status?.is_meets_veteran_definition === false"
                      (change)="onChangeVeteranDefinition($event)" />
                    <label class="form-check-label mt-1" for="veteranNo">No</label>
                  </div>
                </div>
              </div>
              <div class="col-md-3 mb-3">
                <label class="form-label">Are you currently serving on active duty? <span
                    class="text-danger">*</span></label>
                <div class="d-flex align-items-center mt-2" style="gap: 1rem">
                  <div class="form-check mb-0">
                    <input class="form-check-input" type="radio" name="activeDuty" id="activeDutyYes" value="yes"
                      [checked]="pf_veteran_status?.is_on_active_duty === true" (change)="onChangeActiveDuty($event)" />
                    <label class="form-check-label mt-1" for="activeDutyYes">Yes</label>
                  </div>
                  <div class="form-check mb-0">
                    <input class="form-check-input" type="radio" name="activeDuty" id="activeDutyNo" value="no"
                      [checked]="pf_veteran_status?.is_on_active_duty === false"
                      (change)="onChangeActiveDuty($event)" />
                    <label class="form-check-label mt-1" for="activeDutyNo">No</label>
                  </div>
                </div>
              </div>
              <div class="col-md-3 mb-3">
                <label class="form-label">Are you the spouse of an active duty service member? <span
                    class="text-danger">*</span></label>
                <div class="d-flex align-items-center mt-2" style="gap: 1rem">
                  <div class="form-check mb-0">
                    <input class="form-check-input" type="radio" name="spouseActiveDuty" id="spouseActiveDutyYes"
                      value="yes" [checked]="pf_veteran_status?.is_spouse_on_active_duty === true"
                      (change)="onChangeSpouseActiveDuty($event)" />
                    <label class="form-check-label mt-1" for="spouseActiveDutyYes">Yes</label>
                  </div>
                  <div class="form-check mb-0">
                    <input class="form-check-input" type="radio" name="spouseActiveDuty" id="spouseActiveDutyNo"
                      value="no" [checked]="pf_veteran_status?.is_spouse_on_active_duty === false"
                      (change)="onChangeSpouseActiveDuty($event)" />
                    <label class="form-check-label mt-1" for="spouseActiveDutyNo">No</label>
                  </div>
                </div>
              </div>
              <div class="col-md-3 mb-3">
                <label class="form-label">Are you the spouse of a veteran? <span class="text-danger">*</span></label>
                <div class="d-flex align-items-center mt-2" style="gap: 1rem">
                  <div class="form-check mb-0">
                    <input class="form-check-input" type="radio" name="spouseVeteran" id="spouseVeteranYes" value="yes"
                      [checked]="pf_veteran_status?.is_spouse_of_veteran === true || pf_veteran_status?.is_spouse_veteran === true"
                      (change)="onChangeSpouseVeteran($event)" />
                    <label class="form-check-label mt-1" for="spouseVeteranYes">Yes</label>
                  </div>
                  <div class="form-check mb-0">
                    <input class="form-check-input" type="radio" name="spouseVeteran" id="spouseVeteranNo" value="no"
                      [checked]="pf_veteran_status?.is_spouse_of_veteran === false || pf_veteran_status?.is_spouse_veteran === false"
                      (change)="onChangeSpouseVeteran($event)" />
                    <label class="form-check-label mt-1" for="spouseVeteranNo">No</label>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-3 mb-3" *ngIf="
                pf_veteran_status?.is_spouse_on_active_duty === true ||
                pf_veteran_status?.is_on_active_duty === true ||
                pf_veteran_status?.is_meets_veteran_definition === true ||
                pf_veteran_status?.is_spouse_of_veteran === true
              ">
              <label class="form-label">Branch of Service – Check all that apply: <span
                  class="text-danger">*</span></label>
              <!-- <input type="text" class="form-control" placeholder="Select Branch Of Service"
                [value]="pf_veteran_status?.cd_branch_of_service" /> -->
              <div class="branch-service-readonly">
                <div class="p-multiselect-token-container">
                  <span *ngFor="let branch of getBranchOfServiceArray(pf_veteran_status?.cd_branch_of_service)"
                    class="p-multiselect-token">
                    <span class="p-multiselect-token-label">{{ branch }}</span>
                  </span>
                </div>
                <div *ngIf="getBranchOfServiceArray(pf_veteran_status?.cd_branch_of_service).length === 0"
                  class="no-data-message">
                  No Branch of Service selected
                </div>
              </div>
            </div>
          </div>
        <ng-container *ngTemplateOutlet="supportingDocsTpl; context: { section: 'Veteran Status', label: 'Supporting Documents - Veteran Status' }"></ng-container>
        </div>


        <!-- personal Information Section-->

        <!-- Education Information Section - Only show for regular_initial applications -->
        <h1>Education Information</h1>

        <!-- Academic Background Section -->
        <div class="clearfix border-box">
          <h5 class="Heading1 mb-0">Academic Background</h5>
          <div class="license-body p-3">
            <div class="row mb-4">
              <div class="col-md-12 row ml-3">
                <label class="form-label font-14">Highest Level of Education Completed <span
                    class="text-danger">*</span></label>
                <input type="text" class="form-control w-25 ml-3"
                  [value]="highestEducationRows[0]?.cd_highest_education || ''" placeholder="Select One" />
              </div>
            </div>
            <div class="row mb-4">
              <div class="col-12">
                <app-data-grid *ngIf="educationRows && educationRows.length > 0" [config]="application_education">
                </app-data-grid>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <label class="form-label font-14">Please select how your official transcript will be submitted:
                  <span class="text-danger">*</span></label>
                <div class="mt-3">
                  <div class="form-check mb-3">
                    <input class="form-check-input" type="radio" name="transcriptSubmission" id="mailTranscript"
                      value="mail" [checked]="highestEducationRows[0]?.official_mail_transcript === true" />
                    <label class="form-check-label mt-1 ml-1" for="mailTranscript"> I will mail an official transcript.
                    </label>
                  </div>
                  <div class="form-check">
                    <input class="form-check-input" type="radio" name="transcriptSubmission" id="schoolSends"
                      value="school" [checked]="highestEducationRows[0]?.school_will_send_transcript === true" />
                    <label class="form-check-label mt-1 ml-1" for="schoolSends">
                      My school will send an official transcript.
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        <ng-container *ngTemplateOutlet="supportingDocsTpl; context: { section: 'Academic Background', label: 'Supporting Documents - Academic Background' }"></ng-container>
        </div>
        <div
          *ngIf="application?.cd_application_type === 'Regular - Initial' || application?.cd_application_type?.toLowerCase() === 'add endorsement'">
          <!-- Nevada Testing Section -->
          <div class="clearfix border-box">
            <h5 class="Heading1 mb-0">Nevada Testing</h5>
            <div class="license-body p-3">
              <div class="row mb-3">
                <div class="col-12">
                  <p>Do you have Nevada Testing to Submit?</p>
                  <div class="d-flex align-items-center mt-2 mb-2" style="gap: 1rem">
                    <div class="form-check mb-0">
                      <input class="form-check-input" type="radio" name="nevadaTesting" id="nevadaTestingYes"
                        value="yes" [checked]="application?.chk_nevada_testing === true" />
                      <label class="form-check-label mt-1" for="nevadaTestingYes">Yes</label>
                    </div>
                    <div class="form-check mb-0">
                      <input class="form-check-input" type="radio" name="nevadaTesting" id="nevadaTestingNo" value="no"
                        [checked]="application?.chk_nevada_testing === false" />
                      <label class="form-check-label mt-1" for="nevadaTestingNo">No</label>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-12">
                  <app-data-grid *ngIf="nevadaTestingRows && nevadaTestingRows.length > 0"
                    [config]="application_nevada_testing"> </app-data-grid>
                </div>
              </div>
            </div>
          <ng-container *ngTemplateOutlet="supportingDocsTpl; context: { section: 'Nevada Testing', label: 'Supporting Documents - Nevada Testing' }"></ng-container>
          </div>

          <!-- Out-of-State Testing Section -->
          <div class="clearfix border-box">
            <h5 class="Heading1 mb-0">Out-of-State Testing</h5>
            <div class="license-body p-3">
              <div class="row mb-3">
                <div class="col-12">
                  <p>Do you have Out-of-State Testing to submit?</p>
                  <div class="d-flex align-items-center mt-2 mb-2" style="gap: 1rem">
                    <div class="form-check mb-0">
                      <input class="form-check-input" type="radio" name="outOfStateTesting" id="outOfStateTestingYes"
                        value="yes" [checked]="application?.chk_out_of_state_testing === true" />
                      <label class="form-check-label mt-1" for="outOfStateTestingYes">Yes</label>
                    </div>
                    <div class="form-check mb-0">
                      <input class="form-check-input" type="radio" name="outOfStateTesting" id="outOfStateTestingNo"
                        value="no" [checked]="application?.chk_out_of_state_testing === false" />
                      <label class="form-check-label mt-1" for="outOfStateTestingNo">No</label>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-12">
                  <app-data-grid *ngIf="outOfStateTestingRows && outOfStateTestingRows.length > 0"
                    [config]="application_out_of_state_testing"> </app-data-grid>
                </div>
              </div>
            </div>
          <ng-container *ngTemplateOutlet="supportingDocsTpl; context: { section: 'Out-of-State Testing', label: 'Supporting Documents - Out-of-State Testing' }"></ng-container>
          </div>
        </div>
        <!-- /Education Information Section -->
      </div>

      <!-- Professional Development Section -->
      <div class="pdf-section">
       <div *ngIf="shouldShowProfessionalDevelopment">
          <h1>Professional Development</h1>

          <!-- Introductory Text -->
          <div class="clearfix border-box">
            <div class="border-body p-3 prof-dev-info">
              <p>Enter your professional development activities completed since your {{ licenseMasterRows &&
                licenseMasterRows[0]?.issue_date ? (licenseMasterRows[0]?.issue_date | date : 'MM/dd/yyyy') : '-' }}. A
                minimum of {{ profDevData?.total_prof_dev_hrs }} total clock hours is required for your application.</p>
              <p>As you add coursework, district or charter training, and other professional development, the progress
                indicator below will update automatically. Once you reach {{ profDevData?.total_prof_dev_hrs }} hours or
                more, you have met the requirement and may proceed to the next section.</p>
            </div>
          </div>

          <div class="row mt-4">
            <div class="col-md-4">
              <label for="totalProfDevHours" class="form-label">Total Professional Development Hours</label>
              <input type="number" id="totalProfDevHours" class="form-control" [value]="profDevHours" readonly
                aria-label="Total Professional Development Hours" />
            </div>
          </div>

          <!-- College/University Coursework Section -->
          <div class="clearfix border-box mt-2">
            <h5 class="Heading1 mb-0">College / University Coursework</h5>
            <div class="border-body p-3">
              <div class="row mb-3">
                <div class="col-12">
                  <p>Did you complete any education related college/university coursework since {{ licenseMasterRows &&
                    licenseMasterRows[0]?.issue_date ? (licenseMasterRows[0]?.issue_date | date : 'MM/dd/yyyy') : '-'
                    }}?
                    <span class="text-danger">*</span>
                  </p>
                  <div class="d-flex align-items-center mt-2" style="gap: 1rem">
                    <div class="form-check mb-0">
                      <input class="form-check-input" type="radio" name="collegeCoursework" id="collegeCourseworkYes"
                        [checked]="profDevData?.is_college_univ_coursework === true" />
                      <label class="form-check-label mt-1" for="collegeCourseworkYes">Yes</label>
                    </div>
                    <div class="form-check mb-0">
                      <input class="form-check-input" type="radio" name="collegeCoursework" id="collegeCourseworkNo"
                        [checked]="profDevData?.is_college_univ_coursework !== true" />
                      <label class="form-check-label mt-1" for="collegeCourseworkNo">No</label>
                    </div>
                  </div>
                </div>
              </div>

              <div *ngIf="profDevData?.is_college_univ_coursework === true" class="row mb-3">
                <div class="col-md-6 mb-3">
                  <label class="form-label">Total Semester Credits Earned <span class="text-danger">*</span></label>
                  <input type="text" class="form-control" [value]="profDevData?.college_univ_sem_credits_earned || ''"
                    placeholder="Enter total semester credits" readonly />
                </div>
                <div class="col-md-6 mb-3">
                  <label class="form-label">Professional Development hours
                  </label>
                  <input type="text" class="form-control" [value]="profDevData?.college_univ_prof_dev_hrs || ''"
                    placeholder="Professional Development hours" readonly />
                </div>
              </div>

            </div>
          </div>

          <!-- District/Charter Employment Section -->
          <div class="clearfix border-box">
            <h5 class="Heading1 mb-0">District / Charter Employment</h5>
            <div class="border-body p-3">
              <div class="row mb-3">
                <div class="col-12">
                  <p>Are you currently employed with a Nevada school district or public charter school, or were you
                    employed with one since {{ licenseMasterRows && licenseMasterRows[0]?.issue_date ?
                    (licenseMasterRows[0]?.issue_date | date : 'MM/dd/yyyy') : '-' }}?
                    <span class="text-danger">*</span>
                  </p>
                  <div class="d-flex align-items-center mt-2" style="gap: 1rem">
                    <div class="form-check mb-0">
                      <input class="form-check-input" type="radio" name="districtEmployment" id="districtEmploymentYes"
                        [checked]="profDevData?.is_district_charter_employed === true" />
                      <label class="form-check-label mt-1" for="districtEmploymentYes">Yes</label>
                    </div>
                    <div class="form-check mb-0">
                      <input class="form-check-input" type="radio" name="districtEmployment" id="districtEmploymentNo"
                        [checked]="profDevData?.is_district_charter_employed !== true" />
                      <label class="form-check-label mt-1" for="districtEmploymentNo">No</label>
                    </div>
                  </div>
                </div>
              </div>



              <div *ngIf="profDevData?.is_district_charter_employed === true" class="row">
                <div class="col-12">
                  <app-data-grid [config]="application_prof_dev_district_charter"></app-data-grid>
                </div>
              </div>

            </div>
          <ng-container *ngTemplateOutlet="supportingDocsTpl; context: { section: ['District / Charter Employment', 'Employment', 'Professional Development - District / Charter Employment'], label: 'Supporting Documents - District / Charter Employment' }"></ng-container>
          </div>

          <!-- Additional Professional Development Section -->
          <div class="clearfix border-box">
            <h5 class="Heading1 mb-0">Additional Professional Development</h5>
            <div class="border-body p-3">
              <div class="row mb-3">
                <div class="col-12">
                  <p>Did you complete any additional professional development, such as continuing education from a
                    professional development provider or attending an education conference?
                    <span class="text-danger">*</span>
                  </p>
                  <div class="d-flex align-items-center mt-2" style="gap: 1rem">
                    <div class="form-check mb-0">
                      <input class="form-check-input" type="radio" name="additionalProfDev" id="additionalProfDevYes"
                        [checked]="profDevData?.is_additional_prof_completed === true" />
                      <label class="form-check-label mt-1" for="additionalProfDevYes">Yes</label>
                    </div>
                    <div class="form-check mb-0">
                      <input class="form-check-input" type="radio" name="additionalProfDev" id="additionalProfDevNo"
                        [checked]="profDevData?.is_additional_prof_completed !== true" />
                      <label class="form-check-label mt-1" for="additionalProfDevNo">No</label>
                    </div>
                  </div>
                </div>
              </div>



              <div *ngIf="profDevData?.is_additional_prof_completed === true" class="row">
                <div class="col-12">
                  <app-data-grid *ngIf="profDevAdditionalRows?.length > 0"
                    [config]="application_prof_dev_additional"></app-data-grid>
                </div>
              </div>

            <ng-container *ngTemplateOutlet="supportingDocsTpl; context: { section: 'Additional Professional Development', label: 'Supporting Documents - Additional Professional Development' }"></ng-container>
          </div>
          </div>
        </div>
      </div>
        <!-- /Professional Development Section -->

        <!-- work experience -->
        <div class="pdf-section">
          <div
            *ngIf="application?.cd_application_type === 'Regular - Initial' || application?.cd_application_type?.toLowerCase() === 'add endorsement'">
            <h1>Work Experience</h1>
            <div class="clearfix border-box">
              <h5 class="Heading1 p-3">Verifiable Business and Industry Work Experience</h5>
              <div class="license-body p-3">
                <div class="row mb-1">
                  <div class="col-12">
                    <p>Do you have verifiable business or industry work experience? <span class="text-danger">*</span></p>
                    <div class="d-flex align-items-center mt-2 mb-2" style="gap: 1rem">
                      <div class="form-check mb-0">
                        <input class="form-check-input" type="radio" name="businessExperience"
                          id="businessExperienceYes" value="yes"
                          [checked]="application?.chk_verifiable_business_or_industry_work === true" />
                        <label class="form-check-label mt-1" for="businessExperienceYes">Yes</label>
                      </div>
                      <div class="form-check mb-0">
                        <input class="form-check-input" type="radio" name="businessExperience" id="businessExperienceNo"
                          value="no" [checked]="application?.chk_verifiable_business_or_industry_work === false" />
                        <label class="form-check-label mt-1" for="businessExperienceNo">No</label>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12">
                    <app-data-grid *ngIf="workExperienceRows && workExperienceRows.length > 0"
                      [config]="application_work_experience"> </app-data-grid>
                  </div>
                </div>
              </div>
            <ng-container *ngTemplateOutlet="supportingDocsTpl; context: { section: 'Verifiable Business and Industry Work Experience', label: 'Supporting Documents - Verifiable Business and Industry Work Experience' }"></ng-container>
          </div>
            <div class="clearfix border-box">
              <h5 class="Heading1 p-3">Verifiable Teaching Experience</h5>
              <div class="license-body p-3">
                <div class="row mb-1">
                  <div class="col-12">
                    <p>Do you have verifiable teaching experience? <span class="text-danger">*</span></p>
                    <div class="d-flex align-items-center mt-2 mb-2" style="gap: 1rem">
                      <div class="form-check mb-0">
                        <input class="form-check-input" type="radio" name="teachingExperience"
                          id="teachingExperienceYes" value="yes"
                          [checked]="application?.chk_verifiable_teaching_experience === true" />
                        <label class="form-check-label mt-1" for="teachingExperienceYes">Yes</label>
                      </div>
                      <div class="form-check mb-0">
                        <input class="form-check-input" type="radio" name="teachingExperience" id="teachingExperienceNo"
                          value="no" [checked]="application?.chk_verifiable_teaching_experience === false" />
                        <label class="form-check-label mt-1" for="teachingExperienceNo">No</label>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12">
                    <app-data-grid *ngIf="teachingExperienceRows && teachingExperienceRows.length > 0"
                      [config]="application_teaching_experience"> </app-data-grid>
                  </div>
                </div>
              </div>
            <ng-container *ngTemplateOutlet="supportingDocsTpl; context: { section: ['Verifiable Teaching Experience', 'verifiable-teaching-experience'], label: 'Supporting Documents - Verifiable Teaching Experience' }"></ng-container>
         </div>
          </div>

          <!-- work experience -->

          <!-- Background Check -->

          <h1 *ngIf=" application?.cd_application_type?.toLowerCase() !== 'add endorsement'">Background Check</h1>
          <div *ngIf=" application?.cd_application_type?.toLowerCase() !== 'add endorsement'"
            class="clearfix border-box">
            <h5 class="Heading1 p-3">History Disclosure</h5>
            <div class="license-body p-3">
              <div class="row mb-1">
                <div class="col-12">
                  <div class="form-check">
                    <div class="col-md-12 mb-1">
                      <label class="form-label">Have you ever had a professional certificate or license revoked,
                        suspended, or denied for cause
                        in any state? <span class="text-danger">*</span></label>
                      <div class="d-flex align-items-center mt-2" style="gap: 1rem">
                        <div class="form-check mb-0">
                          <input class="form-check-input" type="radio" name="has_suspended_or_revoked_license"
                            id="has_suspended_or_revoked_license_Yes" value="yes"
                            [checked]="application_background_check?.has_suspended_or_revoked_license == true" />
                          <label class="form-check-label mt-1" for="has_suspended_or_revoked_license_Yes">Yes</label>
                        </div>
                        <div class="form-check mb-0">
                          <input class="form-check-input" type="radio" name="has_suspended_or_revoked_license"
                            id="has_suspended_or_revoked_license_No" value="no"
                            [checked]="application_background_check?.has_suspended_or_revoked_license == false" />
                          <label class="form-check-label mt-1" for="has_suspended_or_revoked_license_No">No</label>
                        </div>
                      </div>
                      <div class="mt-3" *ngIf="application_background_check?.has_suspended_or_revoked_license == true">
                        <label for="description" class="form-label">
                          Description <span class="requiredfield text-danger">*</span>
                        </label>
                        <textarea class="form-control history-disclosure-textarea"
                          [rows]="calculateTextareaRows(application_background_check?.suspended_revoked_desc)"
                          id="description"
                          readonly>{{ application_background_check?.suspended_revoked_desc || '' }}</textarea>
                      </div>
                    </div>
                    <div class="col-md-12 mb-1">
                      <label class="form-label">Do you hold an educator license in any state that is currently suspended
                        or revoked?
                        <span class="text-danger">*</span></label>
                      <div class="d-flex align-items-center mt-2" style="gap: 1rem">
                        <div class="form-check mb-0">
                          <input class="form-check-input" type="radio" name="has_cert_or_license_revoked"
                            id="has_cert_or_license_revoked_Yes" value="yes"
                            [checked]="application_background_check?.has_cert_or_license_revoked == true" />
                          <label class="form-check-label mt-1" for="has_cert_or_license_revoked_Yes">Yes</label>
                        </div>
                        <div class="form-check mb-0">
                          <input class="form-check-input" type="radio" name="has_cert_or_license_revoked"
                            id="has_cert_or_license_revoked_No" value="no"
                            [checked]="application_background_check?.has_cert_or_license_revoked == false" />
                          <label class="form-check-label mt-1" for="has_cert_or_license_revoked_No">No</label>
                        </div>
                      </div>
                      <div class="mt-3" *ngIf="application_background_check?.has_cert_or_license_revoked == true">
                        <label for="description" class="form-label">
                          Description <span class="requiredfield text-danger">*</span>
                        </label>
                        <textarea class="form-control history-disclosure-textarea"
                          [rows]="calculateTextareaRows(application_background_check?.cert_or_license_revoked_desc)"
                          id="description"
                          readonly>{{ application_background_check?.cert_or_license_revoked_desc || '' }}</textarea>
                      </div>
                    </div>
                    <div class="col-md-12 mb-1">
                      <label class="form-label">Have you ever received a reprimand or other disciplinary action
                        involving
                        any professional
                        certification or license? <span class="text-danger">*</span></label>
                      <div class="d-flex align-items-center mt-2" style="gap: 1rem">
                        <div class="form-check mb-0">
                          <input class="form-check-input" type="radio" name="has_disciplinary_action"
                            id="has_disciplinary_action_Yes" value="yes"
                            [checked]="application_background_check?.has_disciplinary_action == true" />
                          <label class="form-check-label  mt-1" for="has_disciplinary_action_Yes">Yes</label>
                        </div>
                        <div class="form-check mb-0">
                          <input class="form-check-input" type="radio" name="has_disciplinary_action"
                            id="has_disciplinary_action_No" value="no"
                            [checked]="application_background_check?.has_disciplinary_action == false" />
                          <label class="form-check-label mt-1" for="has_disciplinary_action_No">No</label>
                        </div>
                      </div>
                      <div class="mt-3" *ngIf="application_background_check?.has_disciplinary_action == true">
                        <label for="description" class="form-label">
                          Description <span class="requiredfield text-danger">*</span>
                        </label>
                        <textarea class="form-control history-disclosure-textarea"
                          [rows]="calculateTextareaRows(application_background_check?.disciplinary_action_desc)"
                          id="description"
                          readonly>{{ application_background_check?.disciplinary_action_desc || '' }}</textarea>
                      </div>
                    </div>
                    <div class="col-md-12 mb-1">
                      <label class="form-label">Have you ever been convicted of any criminal offense other than a
                        traffic
                        violation?
                        <span class="text-danger">*</span></label>
                      <div class="d-flex align-items-center mt-2" style="gap: 1rem">
                        <div class="form-check mb-0">
                          <input class="form-check-input" type="radio" name="has_criminal_conviction"
                            id="has_criminal_conviction_Yes" value="yes"
                            [checked]="application_background_check?.has_criminal_conviction == true" />
                          <label class="form-check-label mt-1" for="has_criminal_conviction_Yes">Yes</label>
                        </div>
                        <div class="form-check mb-0">
                          <input class="form-check-input" type="radio" name="has_criminal_conviction"
                            id="has_criminal_conviction_No" value="no"
                            [checked]="application_background_check?.has_criminal_conviction == false" />
                          <label class="form-check-label mt-1" for="has_criminal_conviction_No">No</label>
                        </div>
                      </div>
                      <div class="mt-3" *ngIf="application_background_check?.has_criminal_conviction == true">
                        <label for="description" class="form-label">
                          Description <span class="requiredfield text-danger">*</span>
                        </label>
                        <textarea class="form-control history-disclosure-textarea"
                          [rows]="calculateTextareaRows(application_background_check?.criminal_conviction_desc)"
                          id="description"
                          readonly>{{ application_background_check?.criminal_conviction_desc || '' }}</textarea>
                      </div>
                    </div>
                    <div class="col-md-12 mb-1">
                      <label class="form-label">Have you ever been arrested for any sexual offense involving a minor or
                        pupil?
                        <span class="text-danger">*</span></label>
                      <div class="d-flex align-items-center mt-2" style="gap: 1rem">
                        <div class="form-check mb-0">
                          <input class="form-check-input" type="radio" name="has_sexual_offense"
                            id="has_sexual_offense_Yes" value="yes"
                            [checked]="application_background_check?.has_sexual_offense_arrest == true" />
                          <label class="form-check-label mt-1" for="has_sexual_offense_Yes">Yes</label>
                        </div>
                        <div class="form-check mb-0">
                          <input class="form-check-input" type="radio" name="has_sexual_offense"
                            id="has_sexual_offense_No" value="no"
                            [checked]="application_background_check?.has_sexual_offense_arrest == false" />
                          <label class="form-check-label mt-1" for="has_sexual_offense_No">No</label>
                        </div>
                      </div>
                      <div class="mt-3" *ngIf="application_background_check?.has_sexual_offense_arrest == true">
                        <label for="description" class="form-label">
                          Description <span class="requiredfield text-danger">*</span>
                        </label>
                        <textarea class="form-control history-disclosure-textarea"
                          [rows]="calculateTextareaRows(application_background_check?.sexual_offense_arrest_desc)"
                          id="description"
                          readonly>{{ application_background_check?.sexual_offense_arrest_desc || '' }}</textarea>
                      </div>
                    </div>
                    <div class="col-md-12 mb-1">
                      <label class="form-label">Has an allegation of child abuse ever been substantiated against you by
                        a
                        law enforcement agency,
                        child welfare agency, or court? <span class="text-danger">*</span></label>
                      <div class="d-flex align-items-center mt-2" style="gap: 1rem">
                        <div class="form-check mb-0">
                          <input class="form-check-input" type="radio" name="has_child_abuse" id="has_child_abuse_Yes"
                            value="yes"
                            [checked]="application_background_check?.has_child_abuse_substantiated == true" />
                          <label class="form-check-label mt-1" for="has_child_abuse_Yes">Yes</label>
                        </div>
                        <div class="form-check mb-0">
                          <input class="form-check-input" type="radio" name="has_child_abuse" id="has_child_abuse_No"
                            value="no"
                            [checked]="application_background_check?.has_child_abuse_substantiated == false" />
                          <label class="form-check-label mt-1" for="has_child_abuse_No">No</label>
                        </div>
                      </div>
                      <div class="mt-3" *ngIf="application_background_check?.has_child_abuse_substantiated == true">
                        <label for="description" class="form-label">
                          Description <span class="requiredfield text-danger">*</span>
                        </label>
                        <textarea class="form-control history-disclosure-textarea"
                          [rows]="calculateTextareaRows(application_background_check?.child_abuse_substantiated_desc)"
                          id="description"
                          readonly>{{ application_background_check?.child_abuse_substantiated_desc || '' }}</textarea>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
           <ng-container *ngTemplateOutlet="supportingDocsTpl; context: { section: 'History Disclosure', label: 'Supporting Documents - History Disclosure' }"></ng-container>
       </div>
        </div>
        <div *ngIf=" application?.cd_application_type?.toLowerCase() !== 'add endorsement'" class="pdf-section">
          <div class="clearfix border-box">
            <h5 class="Heading1 p-3">Fingerprint Background Waiver</h5>
            <div class="license-body p-3">
              <div class="row mb-3">
                <div class="col-12">
                  <span>As an applicant who is the subject of a Federal Bureau of Investigation (FBI) fingerprint-based
                    criminal history record check for a noncriminal justice purpose you have certain rights which are
                    discussed below.</span>
                  <ol class="ml-3">
                    <li>
                      <span class="ml-2">You must be notified by Nevada Department of Education that your fingerprints
                        will be used to
                        check the criminal history records of the FBI and the State of Nevada.</span>
                    </li>
                    <li>
                      <span class="ml-2">
                        If you have a criminal history record, the officials making a determination of your suitability
                        for the job, license or other benefit for which you are applying must provide you the
                        opportunity
                        to complete or challenge the accuracy of the information in the record. You may review and
                        challenge the accuracy of the criminal history records which are returned to the licensing
                        agency.
                        The proper forms and procedures will be furnished to you by the Nevada Department of Public
                        Safety, Records Bureau upon request. If you decide to challenge the accuracy or completeness of
                        your FBI criminal history record, Title 28 of the Code of Federal Regulations Section 16.34
                        provides for the proper procedure to do so:</span>
                      <ul class="ml-3">
                        <li>
                          <strong>16.34 - Procedure to obtain change, correction or updating of identification
                            records.</strong>
                        </li>
                        <ul class="ml-3">
                          <li>
                            If, after reviewing his/her identification record, the subject believes that it is incorrect
                            or incomplete in any respect and wishes changes, corrections or updating of the alleged
                            deficiency, he/she should make an application directly to the agency which contributed the
                            questioned information. The subject of a record may also direct his/her challenge as to the
                            accuracy or completeness of any entry on his/her record to the FBI, Criminal Justice
                            Information Services (CJIS) Division ATTN: SCU, Mod. D-2, 1000 Custer Hollow Road,
                            Clarksburg,
                            WV 26306. The FBI will then forward the challenge to the agency which submitted the data
                            requesting that agency to verify or correct the challenged entry. Upon the receipt of an
                            official communication directly from the agency which contributed the original information,
                            the FBI CJIS Division will make any changes necessary in accordance with the information
                            supplied by that agency.
                          </li>
                        </ul>
                      </ul>
                    </li>
                    <li>
                      <span class="ml-2">Based on 28 CFR § 50.12 (b), officials making such determinations should not
                        deny
                        the license or
                        employment based on information in the record until the applicant has been afforded a reasonable
                        time to correct or complete the record or has declined to do so.</span>
                    </li>
                    <li>
                      <span class="ml-2">You have the right to expect that officials receiving the results of the
                        fingerprint-based
                        criminal history record check will use it only for authorized purposes and will not retain or
                        disseminate it in violation of federal or state statute, regulation or executive order, or rule,
                        procedure or standard established by the National Crime Prevention and Privacy Compact
                        Council.</span>
                    </li>
                    <li>
                      <span class="ml-2">I hereby authorize Nevada Department of Education to submit a set of my
                        fingerprints to the
                        Nevada Department Public Safety, Records Bureau for the purpose of accessing and reviewing State
                        of Nevada and FBI criminal history records that may pertain to me. In giving this authorization,
                        I
                        expressly understand that the records may include information pertaining to notations of arrest,
                        detainments, indictments, information or other charges for which the final court disposition is
                        pending or is unknown to the above referenced agency. For records containing final court
                        disposition information, I understand that the release may include information pertaining to
                        dismissals, acquittals, convictions, sentences, correctional supervision information and
                        information concerning the status of my parole or probation when applicable.</span>
                    </li>
                    <li>
                      <span class="ml-2">I hereby release from liability and promise to hold harmless under any and all
                        causes of legal
                        action, the State of Nevada, its officer(s), agent(s) and/or employee(s) who conducted my
                        criminal
                        history records search and provided information to the submitting agency for any statement(s),
                        omission(s), or infringement(s) upon my current legal rights. I further release and promise to
                        hold harmless and covenant not to sue any persons, firms, institutions or agencies providing
                        such
                        information to the State of Nevada on the basis of their disclosures. I have signed this release
                        voluntarily and of my own free will.</span>
                    </li>
                  </ol>
                </div>
              </div>
               <div class="row mb-3">
                <div class="col-12">
                  <div class="p-field col-lg-3 col-md-3 col-sm-6 col-12 signfont">
                    <label class="referral-form-labels common-label">First and Last Name Initials
                      <span class="requiredfield text-danger"> *</span></label>
                    <input type="text" class="form-control" placeholder="Enter First & Last Name Initials"
                      [value]="((user?.person?.strFirstName?.charAt(0) || '') + (user?.person?.strLastName?.charAt(0) || '')).toLowerCase()"
                      maxlength="5" readonly />
                  </div>
                </div>
              </div>
            </div>
          </div>

           <div class="clearfix border-box">
            <h5 class="Heading1 p-3">Statewide Central Registry Waiver</h5>
            <div class="license-body p-3">
              <div class="row mb-3">
                <div class="col-12">
                  <p>Pursuant to NRS 391.033(3)(b), I hereby authorize the Superintendent of Public.</p>
                </div>
              </div>
              <div class="row mb-3">
                <div class="col-12">
                  <div class="p-field col-lg-3 col-md-3 col-sm-6 col-12 signfont">
                    <label class="referral-form-labels common-label">First and Last Name Initials
                      <span class="requiredfield text-danger"> *</span></label>
                    <input type="text" class="form-control" placeholder="Enter First & Last Name Initials"
                      [value]="((user?.person?.strFirstName?.charAt(0) || '') + (user?.person?.strLastName?.charAt(0) || '')).toLowerCase()"
                      maxlength="5" readonly />
                  </div>
                </div>
              </div>
            </div>
         <div class="clearfix border-box">
          <h5 class="Heading1 p-3">Child Support Disclosure</h5>
          <p class="p-3">
            Professional or occupational licenses, certificates or permits will be denied or restricted if back child
            support is owed by the person holding the license. Pursuant to NRS 391.034, an educator license issued by
            the Nevada Depart of Education is subject to this requirement. Please mark the appropriate response. Failure
            to mark one of the options may result in denial of your application.
            <span class="requiredfield text-danger">*</span>
          </p>
          <div class="ml-3 mb-3">
            <div class="d-flex mb-2" style="align-items: flex-start;">
              <input type="radio" name="child_discloure" style="margin-top: 4px; flex-shrink: 0; width: 16px; height: 16px;"
                [checked]="application_background_check?.is_not_subject_child_support == true" />
              <label class="ml-2 mb-0" style="display: inline-block; word-wrap: break-word; overflow-wrap: break-word;"> I<strong> am NOT</strong> subject to court order for the support of a child.</label>
            </div>
            <div class="d-flex mb-2" style="align-items: flex-start;">
              <input type="radio" name="child_discloure" style="margin-top: 4px; flex-shrink: 0; width: 16px; height: 16px;"
                [checked]="application_background_check?.is_subject_child_support_compliant == true" />
              <label class="ml-2 mb-0" style="display: inline-block; word-wrap: break-word; overflow-wrap: break-word;">I <strong> am subject </strong> to court order for the support of one more children
                and <strong> am in compliance </strong> with the order or
                <strong> am in compliance </strong> with a plan approved by the district attorney or other public agency
                enforcing the
                order for the repayment of the amount owed pursuant to the order.</label>
            </div>
            <div class="d-flex mb-2" style="align-items: flex-start;">
              <input type="radio" name="child_discloure" style="margin-top: 4px; flex-shrink: 0; width: 16px; height: 16px;"
                [checked]="application_background_check?.is_subject_child_support_noncompliant == true" />
              <label class="ml-2 mb-0" style="display: inline-block; word-wrap: break-word; overflow-wrap: break-word;">I <strong> am subject </strong> to court order for the support of one more children
                and <strong> am NOT in compliance </strong> with the
                order or <strong> am NOT in compliance </strong> with a plan approved by the district attorney or other
                public agency
                enforcing the order for the repayment of the amount owed pursuant to the order.</label>
            </div>
          </div>
          <div class="row mb-3 ml-3">
            <div class="col-12">
              <div class="p-field col-lg-3 col-md-3 col-sm-6 col-12 signfont">
                <label class="referral-form-labels common-label">First and Last Name Initials
                  <span class="requiredfield text-danger"> *</span></label>
                <input type="text" class="form-control" placeholder="Enter First & Last Name Initials"
                  [value]="((user?.person?.strFirstName?.charAt(0) || '') + (user?.person?.strLastName?.charAt(0) || '')).toLowerCase()"
                  maxlength="5" readonly />
              </div>
            </div>
          </div>
        </div>
        </div>

        <!-- Background Check -->

        <!-- Acknowledgements -->
        <div class="pdf-section">
          <h1>Acknowledgements</h1>
          <div class="clearfix border-box">
            <h5 class="Heading1 p-3">Mandatory Reporting Notification</h5>
            <div class="license-body p-3">
              <div class="row mb-3">
                <div class="col-12">
                  <p class="mb-4">
                    Pursuant to NRS 432B.220, any person employed by a public school or private school, and any person
                    who
                    serves as a volunteer at such a school, who in his or her professional or occupational capacity
                    knows
                    or has reasonable cause to believe that a child has been abused or neglected: shall report the abuse
                    or neglect of the child to an agency which provides child welfare services or to a law enforcement
                    agency, and shall make such a report as soon as reasonably practicable but not later than 24 hours
                    after the person knows or has reasonable cause to believe that the child has been abused or
                    neglected.
                    If the abuse or neglect involves an act or omission of a person directly responsible or serving as a
                    volunteer for, or an employee of, a public or private home, institution or facility where the child
                    is
                    receiving child care outside the home for a portion of the day, the person shall make the report to
                    a
                    law enforcement agency. If the abuse or neglect involves an act or omission of an agency which
                    provides child welfare services, or a law enforcement agency, the person shall make the report to an
                    agency other than the one alleged to have committed the act or omission.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="clearfix border-box">
            <h5 class="Heading1 p-3">Nevada Business License Information</h5>
            <div class="license-body p-3">
              <div class="row mb-3">
                <div class="col-12">
                  <p class="p-3">
                    Please indicate the status of your Nevada Business License by selecting one of the options below:
                  </p>
                  <div class="ml-3">
                    <label class="d-flex align-items-center">
                      <input type="radio" name="license_info"
                        [checked]="application_acknowledgement?.is_dont_have_license_number" />
                      <span class="ml-2">I do not have a Nevada Business license number.</span>
                    </label>
                    <label class="d-flex align-items-center">
                      <input type="radio" name="license_info"
                        [checked]="application_acknowledgement?.is_applied_nevada_license_number" />
                      <span class="ml-2">I have applied for a Nevada Business License with the Nevada Secretary of State
                        in compliance
                        with provisions of NRS Chapter 76, and my application is Pending.</span>
                    </label>
                    <label class="d-flex align-items-center">
                      <input type="radio" name="license_info"
                        [checked]="application_acknowledgement?.is_have_nevada_license_number" />
                      <span class="ml-2">I have a Nevada Business License with the Nevada Secretary of State in
                        compliance
                        with provisions
                        of NRS Chapter 76, and my application is Pending.</span>
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="clearfix border-box">
            <h5 class="Heading1 mb-0">Oath of Office</h5>
            <div class="border-body p-3">
              <p class="mb-3">
                Pursuant to NRS 391.080, all applicants for licensure as an educator must subscribe to the Oath of
                Office
                as specified in the Nevada Constitution:
              </p>
              <p class="mb-3">
                I, do solemnly swear (or affirm) that I will support, protect and defend the constitution and government
                of the United States, and the constitution and government of the State of Nevada against all enemies,
                whether domestic or foreign, and that I will bear true faith, allegiance and loyalty to the same, any
                ordinance, resolution or law of any state notwithstanding, and that I will well and faithfully perform
                all
                the duties of the office or position on which I am about to enter, (if an oath) so help me God; (if an
                affirmation) under the pains and penalties of perjury.
              </p>
              <p class="mb-3">
                In consideration for processing my application I, the undersigned, whose name and signature voluntarily
                appears below; do hereby and irrevocably agree to the above, including all applicable provisions of the
                Fingerprint Background Waiver, the Child Support Affidavit, and the Oath of Office, and affirm that all
                information provided in this application is true and correct to the best of my knowledge.
              </p>
              <p class="mb-4">
                By typing your full name below, you are electronically signing this application and certifying that the
                information provided is true and complete to the best of your knowledge.
              </p>
              <div class="row mb-3">
                <div class="col-12">
                  <div class="p-field col-lg-3 col-md-3 col-sm-6 col-12 signfont">
                    <label for="signature" class="referral-form-labels common-label">Signature – Applicant’s Full Name
                      <span class="requiredfield text-danger"> *</span></label>
                    <input id="signature" type="text" class="form-control" placeholder="Enter First & Last Name"
                      aria-describedby="signature" [value]="application_acknowledgement?.oath_of_office_signature" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Acknowledgements -->

        <!-- Fee and Payments -->
        <div class="pdf-section" *ngIf="paymentTableData && paymentTableData.length > 0">
          <h1>Fee and Payment</h1>
          <div class="clearfix border-box">
            <h5 class="Heading1 p-3">Payment History</h5>
            <div class="license-body p-3">
              <div class="row mb-3">
                <div class="col-12">

                  <div class="payment-success-table-wrapper" style="margin-top: 32px;">
                    <app-data-grid *ngIf="paymentTableData && paymentTableData.length > 0"
                      [config]="paymentGridConfig"></app-data-grid>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- Acknowledgements -->
        </div>
      </div>
      </div>
      <div *ngIf="application?.cd_application_type?.toLowerCase()==='surrender'">
        <div class="surrender-application-container">
          <div class="container-body pb-3 pt-3">
            <div class="license-wrapper border-box mb-3">
              <h5 class="Heading1 mb-0">Application Instruction</h5>
              <div class="p-3 section-body border-box-section ">
                <div class="f-14 mb-3">
                  Welcome to OPAL, the Nevada Department of Education’s Online Portal for Application and Licensure!
                  This
                  new system will allow you to apply for a license or endorsement, renew an existing license, clear a
                  provision on an existing license, and update personal or contact information securely online.
                </div>
                <div class="f-14 mb-3">
                  Once you apply and submit payment for a license or renewal, your receipt will be emailed to you, along
                  with information on how to submit your fingerprints for a background check. You will continue to
                  receive
                  text message and email updates as your application moves through the review and approval process. When
                  your background check clears and your application is approved, your official license will be sent to
                  you
                  via email.
                </div>
                <div class="f-14 mb-3">
                  All applicants will be required to provide a copy of a valid government-issued photo ID. Licenses are
                  issued with legal names and verification of legal name change will be required if any documents are
                  under a name other than what is on the government-issued photo ID.
                </div>
                <div class="f-14 mb-3">
                  Official hard copy transcripts can be sent via mail at the address provided on the Education tab of
                  the
                  application. If you mail in your transcripts, they must be original transcripts bearing the college or
                  university seal. They do not have to be in a sealed envelope from the institution. Official electronic
                  transcripts can be sent to transcripts@doe.nv.gov. Electronic transcripts will be accepted only if
                  they
                  are transmitted directly to the Department of Education from an accredited college or university if
                  the
                  institution is its own clearinghouse, or a recognized clearinghouse such as e-Script. Applicants may
                  not
                  email copies of their own transcripts. Test score reports and most other supporting documents may be
                  uploaded within the online application.
                </div>
                <div class="f-14 mb-3">
                  Applicants for a first-time license or renewal of a license must submit fingerprints for a background
                  check pursuant to NRS 391.033. If you live in Nevada, you may submit your fingerprints electronically
                  via Livescan. Applicants outside of Nevada who cannot submit prints via Livescan, and must submit a
                  fingerprint card (FBI form FD-258) in person or by mail. Learn more about the
                  <a href="https://doe.nv.gov/educator-licensure/background-process/" class="text-primary" target="_blank" rel="noopener noreferrer">fingerprinting and background process</a>.
                </div>
                <div class="f-14 mb-2">
                  Additional information on the licensure process, as well as the minimum qualifications for licensure,
                  may be found on our
                   <a href="https://doe.nv.gov/educator-licensure/" target="_blank" rel="noopener noreferrer"><u>website</u></a>.
                </div>
              </div>
            </div>
            <div
              *ngIf="surrenderApplicationData?.application_type == 'ARL (Alternative Route to Licensure)' || surrenderApplicationData?.application_type == 'Substitute + ARL'"
              class="license-wrapper border-box mb-3">
              <h5 class="Heading1 mb-0">Provider</h5>
              <div class="p-3 section-body border-box-section ">
                <div class="ml-1 row responsive-row ">
                  <div class="col-6  pl-1 pr-0 d-flex flex-column responsive-col">
                    <div class="form-label">ARL Provider</div>
                    <div class="dropdown-clear-wrapper">
                      <input type="text" class="form-control" placeholder="Select ARL Provider"
                        [value]="surrenderApplicationData?.provider_name" readonly>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="license-wrapper border-box mb-3">
              <h5 class="Heading1 mb-0">Surrender Endorsement</h5>
              <div class="p-3 section-body border-box-section ">
                <div>
                  <div class="row ">
                    <div class="col-12">
                      <h5>Surrender Endorsement</h5>
                      <app-data-grid [config]="surrenderEndorsementGrid" id="surrender_license_kind">
                      </app-data-grid>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Notes start -->
            <div class="license-wrapper border-box">
              <h5 class="Heading1 mb-0">Notes</h5>
              <div class="p-3 section-body border-box-section ">
                <div class="mb-3">
                  <div class="responsive-row ">
                    <div class="col-lg-6 col-md-6  pl-1 pr-0 d-flex flex-column responsive-col">
                      <div class="form-label">Section</div>
                      <div class="dropdown-clear-wrapper">
                        <input type="text" class="form-control" placeholder="Select Section"
                          value="Surrender Endorsement" [disabled]="true">
                      </div>
                    </div>
                  </div>
                  <div class="form-group position-relative mt-3">
                    <label for="input_fingerprint_form_note">Notes</label>
                    <textarea id="input_fingerprint_form_note" class="form-control" maxlength="4000"
                      placeholder="Enter Notes">
                          </textarea>
                  </div>
                </div>
                <app-data-grid id="SurrenderNotesGrid" [config]="surrenderNotesGridConfig">
                </app-data-grid>
              </div>
            </div>
            <!-- Notes end-->
            <!--acknowledgement start-->
            <div class="license-wrapper border-box mb-3">
              <h5 class="Heading1 mb-0">Acknowledgement</h5>
              <div class="p-3 section-body border-box-section">
                <div class="row mb-3">
                  <div class="col-12">
                    <p>
                      By typing your full name below, you are electronically signing this application and certifying
                      that
                      the information provided is true and complete to the best of your knowledge.
                    </p>
                  </div>
                </div>
                <div class="row mb-2">
                  <div class="col-md-6">
                    <div class="form-label mb-2">Signature – Full Name<span class="text-danger">*</span>

                      <img src="../../assets/images/neveda-images/Info.svg" alt="Info" width="14" height="14"
                        class="filter-icon ml-1">
                    </div>
                    <input [value]="surrenderPersonData?.person_name" class="form-control"
                      placeholder="Enter First & Last Name" style="font-style: italic" />
                  </div>
                </div>
                <span class="mt-2">Please sign using the <strong>Educator Name</strong> listed in the header of your
                  application</span>
              </div>
            </div>
            <!--acknowledgement end-->
            <hr>

          </div>

        </div>

      </div>
    </div>
  </div>
